import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Stack, Typography as MuiTypography } from '@mui/material'
import MinimumStateOfChargeSlider from './MinimumStateOfChargeSlider'
import MinimumStateOfChargeNumberField from './MinimumStateOfChargeNumberField'
import { Typography } from '@e3dc-react/shell/Elements/Typography'

interface Props {
  value: number | null
  onChange: (value: number) => void
  chargeLimitMax?: number
}

/**
 * Slider and number field for setting the target state of charge.
 */
const StateOfChargeSelector: React.FC<Props> = ({ value, onChange, chargeLimitMax }) => {
  const { t } = useCustomTranslation()

  return (
    <Stack mt={3} gap={2}>
      <MuiTypography variant="body2">{t('emobility.vehicle-integration.state-of-charge.min-soc-description')}</MuiTypography>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <MuiTypography variant="h3">{t('emobility.vehicle-integration.state-of-charge.min-soc-label')}</MuiTypography>
        <Box>
          <MinimumStateOfChargeNumberField value={value ?? 0} onChange={onChange} />
        </Box>
      </Stack>
      <MinimumStateOfChargeSlider value={value ?? 0} onChange={onChange} chargeLimitMax={chargeLimitMax} />
      {value && chargeLimitMax && value > chargeLimitMax && (
        <Typography
          variant="body2"
          values={{
            value: `${chargeLimitMax} %`,
          }}
          components={{
            a: <MuiTypography variant="subtitle1" component="span" />,
          }}
        >
          {'emobility.vehicle-integration.state-of-charge.soc-more-than-max-message'}
        </Typography>
      )}
    </Stack>
  )
}

export default StateOfChargeSelector
